// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
function initMainProductAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // clear previous triggers (important on re-init)
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  /* ===============================
     SECTION 1: Product Gallery
  =============================== */
  const galleryRoot = document.querySelector(".s-main-product__gallery");

  if (galleryRoot) {
    const galleryItems = galleryRoot.querySelectorAll(".c-product-gallery__main-item");

    if (galleryItems.length) {
      galleryItems.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              toggleActions: "play none none reverse"
            }
          }
        );
      });
    }
  }

  /* ===============================
     SECTION 2: Right Column
     (Title, small description, pricing, benefits, accordions)
  =============================== */
  const rightContent = document.querySelector(".s-main-product__content");

  if (rightContent) {
    const rightBlocks = rightContent.querySelectorAll(
      ".s-main-product__benefits, " +
      ".s-main-product__content-wrapper"
    );

    rightBlocks.forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.45,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }

  /* ===============================
     SECTION 3: Related Products
  =============================== */
  const relatedSection = document.querySelector(".s-main-product__related-products");

  if (relatedSection) {
    gsap.fromTo(
      relatedSection,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: relatedSection,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }

  /* ===============================
     SECTION 4: Recommended Products
  =============================== */
  const recommendSection = document.querySelector(".s-recommend-products");

  if (recommendSection) {
    gsap.fromTo(
      recommendSection,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: recommendSection,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }

  /* ===============================
     SECTION 5: Subscription Section
  =============================== */
  const subscriptionSection = document.querySelector(".s-subscription");

  if (subscriptionSection) {
    const subTitle = subscriptionSection.querySelector(".s-subscription__title");
    const subDesc = subscriptionSection.querySelector(".s-subscription__description");
    const subForm = subscriptionSection.querySelector(".s-subscription__form");
    const imageWrapper = subscriptionSection.querySelector(".s-subscription__image-wrapper");
    const subscribeButton = subscriptionSection.querySelector(".s-subscription__button");

    gsap.from([subTitle, subDesc, subForm], {
      y: 20,
      opacity: 0,
      stagger: 0.2,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: subscriptionSection,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });

    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { x: 40, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: "elastic.out(1, 0.4)",
          scrollTrigger: {
            trigger: imageWrapper,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    if (subscribeButton) {
      gsap.fromTo(
        subscribeButton,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: subscribeButton,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }
  }

  // === SECTION 6: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
};

document.addEventListener("DOMContentLoaded", initMainProductAnimations);

const productRoot = document.querySelector(".s-main-product");
if (productRoot) {
  const observer = new MutationObserver(() => {
    requestAnimationFrame(initMainProductAnimations);
  });

  observer.observe(productRoot, {
    childList: true,
    subtree: true,
  });
}
